import React from 'react';
import { Redirect, useParams } from 'react-router';
import { useChatSession } from '../../../../data/hooks/chat/useChatSession';
import { useChatSessionMessages } from '../../../../data/hooks/chat/useChatSessionMessages';
import { useEvent } from '../../../../data/hooks/eventHooks';
import { useChatNotifications } from '../../../../data/hooks/notifications/useChatNotifications';
import { useMarkNotificationsRead } from '../../../../data/hooks/notifications/useMarkNotificationsRead';
import { useEventParticipant } from '../../../../data/hooks/participant/useEventParticipant';
import { useIdListFromQueryString } from '../../../../misc/useIdListFromQueryString';
import WaitWhileBusy from '../../../WaitWhileBusy';
import ChatRoom from './ChatRoom';

export default () => {
    const { eventId, chatSessionId } = useParams(),
        event = useEvent(eventId),
        chatSession = useChatSession(chatSessionId, eventId),
        messages = useChatSessionMessages(chatSessionId),
        unreadNotifications = useChatNotifications({
            chatSessionId,
            filter: (notif) => !notif.read,
        }),
        otherParticipantId = useIdListFromQueryString('participant')[0] ?? chatSession?.otherUserId,
        otherParticipant = {
            ...(useEventParticipant(eventId, { userId: otherParticipantId }) || {}),
            user_id: otherParticipantId,
        };

    useMarkNotificationsRead(unreadNotifications);

    if (!otherParticipant.user_id) return <Redirect to=".." />;

    return (
        <WaitWhileBusy>
            <ChatRoom event={event} messages={messages} chatSession={chatSession} otherParticipant={otherParticipant} />
        </WaitWhileBusy>
    );
};
